import { type RangeerbewegingenModel } from "@personeel/models/RangeerBewegingModel.ts";
import { create } from "zustand";

type RangeerBewegingenState = {
  rangeerbewegingen: RangeerbewegingenModel;
  setRangeerbewegingen: (rb: RangeerbewegingenModel) => void;
};

export const useRangeerbewegingenStore = create<RangeerBewegingenState>((set) => ({
  rangeerbewegingen: [],
  setRangeerbewegingen: (rb) => set({ rangeerbewegingen: rb }),
}));
